import { Alert, Box, IconButton, Typography } from '@evaneos/b2b-ui';
import { useState } from 'react';
import CloseOutlinedIcon from '@evaneos/b2b-ui/icons/CloseOutlined';
import { useIntl } from 'react-intl';

import { useExperimentVariation } from '../../shared/analytics/amplitude-hooks';
import { buildGoogleOAuthUrl } from '../../resources/appointment/operations';
import { useGetCalendarStatus } from '../../resources/appointment/queries';
import { GoogleSignInButton } from '../../design-system/GoogleSignInButton';

export const AppointmentConnectionBanner = (): JSX.Element | null => {
    const { formatMessage } = useIntl();
    const [dismissed, setDismissed] = useState(false);
    const variant = useExperimentVariation('ab-google-calendar');
    const showFeature = variant?.value === 'on' || variant?.value === 'treatment';
    const { data: calendarStatus, isLoading } = useGetCalendarStatus();

    if (!showFeature || isLoading || calendarStatus?.google === 'connected' || dismissed) {
        return null;
    }

    return (
        <Alert
            data-spec-id="calendar-connect-banner"
            severity="info"
            sx={{
                maxWidth: 'none',
                alignItems: 'center',
            }}
            action={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <div data-spec-id="calendar-banner-connect-button">
                        <GoogleSignInButton
                            label="Connectez Google Agenda"
                            onClick={() => window.location.assign(buildGoogleOAuthUrl())}
                        />
                    </div>
                    <IconButton
                        data-spec-id="calendar-banner-dismiss-button"
                        size="small"
                        onClick={() => setDismissed(true)}
                        aria-label={formatMessage({ id: 'global.close' })}
                    >
                        <CloseOutlinedIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                </Box>
            }
        >
            <Typography>
                {/* @todo translate: calendar.banner.text */}
                Gérez vos prises de RDV directement dans Request Manager
            </Typography>
        </Alert>
    );
};
